/**
 * Created by puhui on 2016/11/29.
 */
/*removeAttr("class");*/
require('./header.scss');
$(document).ready(function(){
  /*头部的动态效果*/

  $('.we-chat').click(function(){
    $('.finup-app').css('display','none');
    $('.finup-wechat').toggle();
  });
  $('.phone').click(function(){
    $('.finup-wechat').css('display','none');
    $('.finup-app').toggle();
  });

  var main = {
    init : function(){
      this.bindEvent();
      this.initNav();
    },
    bindEvent () {

    },

    initNav () {
      let path = location.pathname.substr(1).split('/')[0] || 'index';
      this.highLightNav($(`[data-path=${path}]`));
    },

    highLightNav (el) {
      el.addClass('red').siblings().removeClass('red');
    }
  }
  main.init();
});


// WEBPACK FOOTER //
// ./static/common/header/header.js